import { lazyLoad } from 'utils/lazy';

export const Payment = lazyLoad(
  () => import('./Payment'),
  (m) => m.Payment
);
